import React from "react";
import { cn } from "./cn";

/**
 * Bun page header: title left, actions right. Spec: CRM Dashboard v2
 * (eyebrow + 24px hero greeting) and Pipeline (plain 22px title row).
 *
 *   <PageHeader title="Pipeline">
 *     <SegmentedControl ... />
 *     <Button>Add prospect</Button>
 *   </PageHeader>
 *
 * With `eyebrow` set, the header becomes the dashboard hero: caps eyebrow
 * over a 24px display title, actions bottom-aligned.
 */
export default function PageHeader({ back, eyebrow, title, subtitle, size = "default", truncateTitle = false, className, actionsClassName, children }) {
  const heading = (
    <div className={cn("flex font-instrument", back ? "min-w-0 flex-1 gap-1 sm:gap-3" : "gap-3", eyebrow ? "items-end" : "items-center", !back && className)}>
      <div className={cn("min-w-0", truncateTitle && "flex-1")}>
        {eyebrow && (
          <div className="text-bun-label font-semibold uppercase tracking-[0.08em] text-bun-stone">
            {eyebrow}
          </div>
        )}
        <h1
          className={cn(
            "m-0 font-instrument font-semibold leading-tight tracking-[-0.008em] text-bun-text",
            back && "flex min-h-11 items-center sm:min-h-[34px]",
            size === "small" ? "text-bun-heading" : size === "compact" ? "text-bun-number" : back ? "text-bun-number sm:text-bun-display" : "text-bun-display",
            eyebrow && "mt-[5px]"
          )}
        >
          {truncateTitle ? <span className="block truncate" title={typeof title === 'string' ? title : undefined}>{title}</span> : title}
        </h1>
        {subtitle && <p className="m-0 mt-1 text-bun-body text-bun-slate">{subtitle}</p>}
      </div>
      {!truncateTitle && <div className="flex-1" />}
      {children && (
        <div className={cn("flex items-center gap-[10px]", actionsClassName)}>{children}</div>
      )}
    </div>
  );
  return back ? (
    <div className={cn("flex items-start gap-1 sm:gap-3", className)}>
      <div className="shrink-0">{back}</div>
      {heading}
    </div>
  ) : heading;
}
